export default "__VITE_ASSET__BMmep5pc__"